module.exports = __webpack_public_path__ + "img/calendar-new.9e32445f.svg";